module.exports = {"id":"204337","name":"Gervasio Núñez","rating":"72","photo":"./data/images/photos/4/204337.png","club":{"name":"CA Tucumán","logo":"./data/images/clubs/CATucuman.png"},"positions":["MOC","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GervasioNunez0.json
// module id = 1577
// module chunks = 0